import { useEffect, useState } from 'react';
import { getRotation, putRotation, type RotationEntry } from '../api';

export default function Rotation() {
  const [entries, setEntries] = useState<RotationEntry[]>([]);
  const [updatedAt, setUpdatedAt] = useState<string | undefined>();
  const [err, setErr] = useState<string | null>(null);
  const [saving, setSaving] = useState(false);

  async function load() {
    try {
      setErr(null);
      const r = await getRotation();
      setEntries(r.entries);
      setUpdatedAt(r.updatedAt);
    } catch (e) {
      setErr(String(e));
    }
  }
  useEffect(() => void load(), []);

  function addEntry() {
    setEntries((es) => [...es, { network: 'line', adUnitId: '' }]);
  }
  function removeEntry(i: number) {
    setEntries((es) => es.filter((_, idx) => idx !== i));
  }
  function updateEntry(i: number, patch: Partial<RotationEntry>) {
    setEntries((es) => es.map((e, idx) => (idx === i ? { ...e, ...patch } : e)));
  }
  function moveEntry(i: number, dir: -1 | 1) {
    setEntries((es) => {
      const j = i + dir;
      if (j < 0 || j >= es.length) return es;
      const copy = [...es];
      [copy[i], copy[j]] = [copy[j], copy[i]];
      return copy;
    });
  }

  async function save() {
    setSaving(true);
    setErr(null);
    try {
      const r = await putRotation(entries);
      setEntries(r.entries);
      alert('保存しました');
    } catch (e) {
      setErr(String(e));
    } finally {
      setSaving(false);
    }
  }

  return (
    <div>
      <h2>広告ローテーション（グローバル）</h2>
      <p className="muted">
        上から順にローテーション。端末アプリは上の並び順で広告を回す。
      </p>

      <div className="card">
        <div className="row" style={{ justifyContent: 'space-between' }}>
          <div>
            <strong>{entries.length} 件</strong>
            {updatedAt && (
              <span className="muted" style={{ marginLeft: 16 }}>
                最終更新: {updatedAt}
              </span>
            )}
          </div>
          <div className="row">
            <button className="ghost" onClick={addEntry}>
              + 追加
            </button>
            <button disabled={saving} onClick={save}>
              保存
            </button>
          </div>
        </div>
        {err && <div className="error">{err}</div>}

        <table style={{ marginTop: 12 }}>
          <thead>
            <tr>
              <th style={{ width: 60 }}>#</th>
              <th>ネットワーク</th>
              <th>Ad Unit ID</th>
              <th style={{ width: 140 }}>順序</th>
              <th style={{ width: 80 }}></th>
            </tr>
          </thead>
          <tbody>
            {entries.map((e, i) => (
              <tr key={i}>
                <td className="muted">{i + 1}</td>
                <td>
                  <select
                    value={e.network}
                    onChange={(ev) =>
                      updateEntry(i, { network: ev.target.value })
                    }
                  >
                    <option value="line">LINE</option>
                    <option value="applovin">AppLovin</option>
                    <option value="admob">AdMob</option>
                  </select>
                </td>
                <td>
                  <input
                    value={e.adUnitId || ''}
                    onChange={(ev) =>
                      updateEntry(i, { adUnitId: ev.target.value })
                    }
                    style={{ minWidth: 240 }}
                  />
                </td>
                <td>
                  <div className="row" style={{ gap: 4 }}>
                    <button
                      className="ghost small"
                      onClick={() => moveEntry(i, -1)}
                      disabled={i === 0}
                    >
                      ↑
                    </button>
                    <button
                      className="ghost small"
                      onClick={() => moveEntry(i, 1)}
                      disabled={i === entries.length - 1}
                    >
                      ↓
                    </button>
                  </div>
                </td>
                <td>
                  <button
                    className="ghost small"
                    onClick={() => removeEntry(i)}
                  >
                    削除
                  </button>
                </td>
              </tr>
            ))}
            {entries.length === 0 && (
              <tr>
                <td colSpan={5} className="muted">
                  未設定
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
